module.exports = __webpack_public_path__ + "static/media/consult-illustration.f7e95b9c.png";